export default function PersonalIcon() {
  return (
    <svg
      width="208"
      height="187"
      viewBox="0 0 208 187"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.11719 183C5.13176 174.072 14.2223 154.998 42.468 150.128C69.9981 145.381 78.5603 129.84 79.5402 122.104C79.5862 121.741 79.4198 121.4 79.1175 121.193C68.459 113.9 49.3668 90.3626 54.6429 51.5113C59.9999 12.0647 89.7471 3.42057 103.951 4.02931"
        stroke="#0A4763"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M203.178 183C202.163 174.072 193.073 154.998 164.827 150.128C137.297 145.381 128.735 129.84 127.755 122.104C127.709 121.741 127.875 121.4 128.177 121.193C138.836 113.9 157.928 90.3626 152.652 51.5113C147.295 12.0647 117.548 3.42057 103.344 4.02931"
        stroke="#0A4763"
        strokeWidth="8"
        strokeLinecap="round"
      />
    </svg>
  );
}
